import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function FAQSection() {
  const { faqs } = useSettings();
  const [open, setOpen] = useState(faqs[0]?.id || null);

  return (
    <section className="py-28 lg:py-36 bg-[#F5EFE6]">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-14">
          <div className="section-eyebrow mb-4">We Answer</div>
          <h2 className="section-title font-display">Your <span className="italic text-[#B8893C]">Questions</span></h2>
        </div>
        <div className="divide-y divide-[#EBE0CE] border-y border-[#EBE0CE]">
          {faqs.map((f) => {
            const isOpen = open === f.id;
            return (
              <div key={f.id}>
                <button
                  onClick={() => setOpen(isOpen ? null : f.id)}
                  className="w-full flex items-center justify-between text-left py-6 group"
                >
                  <span className="font-display text-xl md:text-2xl tracking-[0.04em] text-[#1F1B17] pr-6">{f.q}</span>
                  <span className="w-10 h-10 rounded-full border border-[#B8893C]/50 flex items-center justify-center text-[#5C2018] group-hover:bg-[#B8893C] group-hover:border-[#B8893C] group-hover:text-white transition">
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <div className={`grid transition-all duration-500 ${isOpen ? "grid-rows-[1fr] opacity-100 pb-6" : "grid-rows-[0fr] opacity-0"}`}>
                  <div className="overflow-hidden">
                    <p className="text-[#3a322a] leading-relaxed max-w-3xl">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
